import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { AuthContext } from '../globalContext/auth/authProvider';
import { getItem, setItem } from '../services/localStorageService';
import {
  LOCAL_STORAGE_KEYS,
  NAVIGATION_CONSTANTS,
  USER_TYPE,
} from '../consts/constants';

function withPublicAccess(Component) {
  return (props) => {
    const userId = getItem(LOCAL_STORAGE_KEYS.USER_ID);
    const userType = getItem(LOCAL_STORAGE_KEYS.USER_TYPE);

    const [authState] = useContext(AuthContext);

    const navigate = useNavigate();
    useEffect(() => {
      if (!userType) {
        setItem(LOCAL_STORAGE_KEYS.USER_TYPE, USER_TYPE.STUDENT);
      }

      if (authState.token && userId) {
        navigate(`${NAVIGATION_CONSTANTS.DASHBOARD}`);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <Component {...props} />;
  };
}

export default withPublicAccess;
